function ddddCorrectSpaceWhenNoPagination() {

    if(document.getElementsByClassName("pagination").length == 0) {

      if(!document.getElementById("ddddSpace")) {

        var spacingDiv = document.createElement("div")
        spacingDiv.setAttribute('id', 'ddddSpace')
        spacingDiv.innerHTML = " "

        var productGridContainer = document.getElementById("ProductGridContainer")
        productGridContainer.parentNode.insertBefore(spacingDiv, productGridContainer.nextSibling)
      }

    } else {
      var spacingDiv = document.getElementById("ddddSpace")
      if(spacingDiv) spacingDiv.remove()
    }
  }

  var gridItems = []
  var ddddKeyItem
  var ddddAutoLoadIsBusy = false
  var ddddCurrentLoadingPage = 1
  var ddddHasMoreItemsToLoad = true

  function ddddUpdateKeyItem() {
    var items = document.getElementsByClassName("grid__item")
    if (items.length > 5) {
      ddddKeyItem = items[items.length-5]
    }
  }

  function ddddIsInViewport(ele) {
      const rect = ele.getBoundingClientRect()
      var h = rect.bottom - rect.top
      return rect.bottom - h <= (window.innerHeight || document.documentElement.clientHeight)
    }

  (function(){

    ddddCorrectSpaceWhenNoPagination()

    document.addEventListener("scroll", function() {

      ddddAutoLoad()

    })

    gridItems = document.getElementById("product-grid").children

    ddddAutoLoad()

  })();

  function ddddCheckToResetFlags() {

    if(ddddAutoLoadIsBusy) return

    var reset = false

    var _gridItems = document.getElementById("product-grid").children

    if (gridItems.length != _gridItems.length) {

      reset = true
    } else {

      for (i = 0; i < gridItems.length; i ++) {
        if(gridItems[i] != _gridItems[i]) {
          reset = true
          break
        }
      }
    }



    if(reset) {
      ddddAutoLoadIsBusy = false
      ddddCurrentLoadingPage = 1
      ddddHasMoreItemsToLoad = true
      ddddCorrectSpaceWhenNoPagination()
    }
  }

  function ddddAutoLoad() {

    ddddCheckToResetFlags()


    if(document.getElementsByClassName("pagination").length == 0 || !ddddHasMoreItemsToLoad || ddddAutoLoadIsBusy) return

    ddddUpdateKeyItem()

    if (ddddKeyItem === undefined || !ddddIsInViewport(ddddKeyItem)) return

    var loader = document.createElement("div")
    loader.setAttribute('id', 'ddddLoader')
    loader.setAttribute('class', 'ddddHeart')
    loader.innerHTML = "<div>&nbsp;</div>"
    document.getElementsByClassName("pagination-wrapper")[0].appendChild(loader)

    ddddCurrentLoadingPage += 1

    let url = ddddGetUrl(ddddCurrentLoadingPage)

    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4) {

        if (this.status == 200) {

          ddddHandleAutoLoadResponse(this)

        } else {
          ddddCurrentLoadingPage -= 1
        }
        ddddAutoLoadIsBusy = false
        loader.remove()
      }
    }
    xhttp.open("GET", url, true)
    xhttp.send()
    ddddAutoLoadIsBusy = true

  }

  function ddddGetUrl(pageNumber) {

    var url = window.location.href
    if(url[url.length-1] == "/") url = url.slice(0, -1)

    if(url.indexOf("?") > 0) {

      url = window.location.href.split('?')[0]

      var vars = {}
      var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
      function(m,key,value) {
        vars[key] = value
      })

      var params = []

      for (var k in vars){
        if (k != "page") {
          params.push(k + "=" + vars[k])

        }
      }

      params.push("page=" + pageNumber)

      if(params.length > 0) {
        url += "?" + params.join("&")
      }
    } else {
      url += "?page=" + pageNumber
    }

    return url
  }

  function ddddHandleAutoLoadResponse(response) {

    var responseText = response.responseText
    var gridStartingIndex = responseText.indexOf('<ul id="product-grid"')

    if(gridStartingIndex > 0) {

      var gridEndingIndex = responseText.indexOf('</ul>', gridStartingIndex) + 5
      var list = responseText.substring(gridStartingIndex, gridEndingIndex)

      var tmp = document.createElement("div")
      tmp.innerHTML = list

      var collection = document.getElementById("product-grid")

      var items = tmp.getElementsByClassName("grid__item")

      while(items.length > 0) {
        collection.appendChild(items[0])
      }

      gridItems = document.getElementById("product-grid").children

    } else {

      ddddHasMoreItemsToLoad = false
    }
  }